import React, { Component } from 'react'
import { ImageViewer } from 'antd-mobile'
import { isVideoFile, isURLValid, formatJSON, decodeHtmlEntities, replaceCDNDomain } from '../../utils'

import './index.less'

export default class Article extends Component {
    render() {
        let { list = [] } = this.props
        if (!list) return null


        const obj = formatJSON(list)

        if (obj) {
            list = Object.values(obj)
            if (list.length === 0) return null
            const images = list.filter(item => item.type === 'image')
            return <div>
                {
                    list.map((item, index) => {
                        return <div key={index}>{this.renderContent(item, images)} </div>
                    })
                }
            </div>
        } else {
            return <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(list) }}></div>
        }

    }
    // 处理图片点击
    handleImageClick = ({ images, value }) => {
        const imgIndex = images.findIndex(item => item.value === value)
        ImageViewer.Multi.show({ images: images.map(item => replaceCDNDomain(item.value)), defaultIndex: imgIndex })
    };

    renderContent = (item, images) => {
        const { type, value } = item
        switch (type) {
            case 'text':
                return <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left', marginBottom: '10px', marginTop: '10px' }} dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(value) }}></div>
            case 'image':
                return <div  style={{ fontSize: 0 }}><img src={replaceCDNDomain(value)} alt="" style={{ width: '100%' }} onClick={() => this.handleImageClick({ images, value })} /></div>
            case 'video':
                if (!isURLValid(value)) {
                    return <div style={{ padding: '10px 0', whiteSpace: 'pre-wrap', textAlign: 'left' }}>{decodeHtmlEntities(value)}</div>
                }
                if (isVideoFile(value)) {
                    return <>
                        <video controls controlsList="nodownload nofullscreen noremoteplayback noplaybackrate" style={{ width: '100%' }}>
                            <source src={replaceCDNDomain(value)} />
                            Your browser does not support the video tag.
                        </video>
                    </>
                } else {
                    return <div>
                        <iframe
                            style={{ width: '100%', border: 0, minHeight: '214px' }}
                            src={value}
                            title="Video"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" autoPlay={true}>
                        </iframe>
                    </div>
                }

            default:
                return null
        }
    }

}
